<template>
  <div class="login-box">
    <logo></logo>
    <div class="login-box-body">
      <p class="alert alert-danger text-center" role="alert" v-show="forgotPasswordFailed">{{
        $t('forgot_password.account_not_found') }}</p>
      <form>
        <div class="form-group has-feedback" :class="{ 'has-error': usernameHasError}">
          <input type="email" id="username" name="username" class="form-control" required="required"
                 :placeholder="$t('general.email')"
                 v-model="username"/>
          <span class="help-block" v-show="usernameHasError">{{ $t('forgot_password.email_mandatory') }}</span>
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <router-link :to="{ name: 'login', query: logoUrlQueryParams }">{{ $t('general.cancel') }}</router-link>
          </div>
          <div class="col-xs-8">
            <button type="submit" class="btn btn-primary btn-block btn-flat" @click.prevent="forgotPassword">
              {{ $t('forgot_password.reinit') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import urlQueryParams from '../mixins/logo-url-query-params'
import Logo from '../components/common/Logo'
import { mapState, mapActions } from 'vuex'

// noinspection JSUnusedGlobalSymbols
export default {
  data () {
    return {
      username: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('user', [
      'forgotPasswordFailed'
    ]),
    usernameHasError: function () {
      return this.submitted && this.username === ''
    }
  },
  methods: {
    ...mapActions('user', {
      handleForgotPassword: 'forgotPassword'
    }),
    forgotPassword: function () {
      this.submitted = true

      if (!this.usernameHasError) {
        this.handleForgotPassword({ username: this.username, lawFirmId: this.$route.query.law_firm_id })
      }
    }
  },
  mixins: [urlQueryParams],
  components: {
    Logo
  }
}
</script>
